import { DateTime } from "luxon";
import { SegmentResults, TemplateResults, TestEvent, TestResult, WelderTest } from "@/api/williams/testEvents";
import { StandardTest } from "@/api/williams/tests";
import { v4 as uuid } from "uuid";
import { Welder } from "@/api/williams/welders";

export function doesWelderHaveTest(testEvent: TestEvent, welder: Welder, test: StandardTest) {
  return testEvent.welderTests.some((x) => x.templateId === test.recordId && x.welderId === welder.welderId);
}

export function doAllWeldersHaveTest(testEvent: TestEvent, test: StandardTest) {
  return testEvent.welders.every((welder) => doesWelderHaveTest(testEvent, welder, test));
}

export function isTestCompleted(testEvent: TestEvent, welder: Welder, test: StandardTest) {
  return testEvent.welderTests.find((x) => x.welderId === welder.welderId && x.templateId === test.recordId)?.submitted;
}

export function areAnyTestsCompleted(testEvent: TestEvent, welder: Welder) {
  return testEvent.welderTests.filter((x) => x.welderId === welder.welderId).some((x) => x.submitted);
}

export function createTestResult(testEvent: TestEvent, welder: Welder, test: StandardTest): WelderTest {
  return {
    testEventWelderTestId: uuid(),
    testEventId: testEvent.id,
    templateId: test.recordId,
    welderId: welder.welderId,
    submitted: false,
  };
}

export function getTemplateResult(template: TemplateResults) {
  if (template.segments.some((x) => x.result === TestResult.Fail)) {
    return TestResult.Fail;
  } else if (template.segments.every((x) => x.result === TestResult.Pass)) {
    return TestResult.Pass;
  } else if (template.segments.every((x) => x.result === TestResult.Pass || x.result === TestResult.NotConducted)) {
    return TestResult.None;
  } else {
    return template.result;
  }
}

export function getSegmentResult(segment: SegmentResults) {
  if (segment.tests.some((x) => x.result === TestResult.Fail)) {
    return TestResult.Fail;
  } else if (segment.tests.every((x) => x.result === segment.tests[0].result)) {
    return segment.tests[0].result;
  } else if (segment.tests.every((x) => x.result === TestResult.Pass || x.result === TestResult.NotConducted)) {
    return TestResult.None;
  } else {
    return segment.result;
  }
}

export function getTestDate(template: TemplateResults) {
  let latest: DateTime | undefined;

  for (const segment of template.segments) {
    if (segment.testDate) {
      const dt = DateTime.fromISO(segment.testDate);
      if (!latest || dt > latest) {
        latest = dt;
      }
    }
  }
  return latest?.toISODate();
}
